const CreateUser = () => {
  return <div>CreateUser</div>;
};

export default CreateUser;
